import { put, takeLatest } from 'redux-saga/effects';
import WizardService from './wizardService';
import {
  LOAD_WIZARD_STATE,
  LOAD_WIZARD_STATE_SUCCESS,
  LOAD_WIZARD_STATE_FAILURE,
  INIT_WIZARD,
  INIT_WIZARD_SUCCESS,
  INIT_WIZARD_FAILURE,
  UPDATE_WIZARD_STEP,
  UPDATE_WIZARD_STEP_SUCCESS,
  UPDATE_WIZARD_STEP_FAILURE,
  SET_CURRENT_STEP,
  SET_CURRENT_STEP_SUCCESS,
  SET_CURRENT_STEP_FAILURE,
  COMPLETE_WIZARD,
  COMPLETE_WIZARD_SUCCESS,
  COMPLETE_WIZARD_FAILURE,
  RESET_WIZARD,
  RESET_WIZARD_SUCCESS,
  RESET_WIZARD_FAILURE,
} from './wizardSlice';

function* loadWizardState({ payload }) {
  try {
    const { shopId, wizardType } = payload;
    const state = yield WizardService.getState(shopId, wizardType);

    yield put({
      type: LOAD_WIZARD_STATE_SUCCESS,
      payload: { wizardType, wizardState: state },
    });
  } catch (error) {
    yield put({
      type: LOAD_WIZARD_STATE_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to load wizard state' },
    });
  }
}

function* initWizard({ payload }) {
  try {
    const { shopId, wizardType, initialData } = payload;
    const state = yield WizardService.init(shopId, wizardType, initialData);

    yield put({
      type: INIT_WIZARD_SUCCESS,
      payload: { wizardType, wizardState: state },
    });
  } catch (error) {
    yield put({
      type: INIT_WIZARD_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to initialize wizard' },
    });
  }
}

function* updateWizardStep({ payload }) {
  try {
    const { shopId, wizardType, stepId, stepIndex, stepData } = payload;
    const state = yield WizardService.updateStep(shopId, wizardType, stepId, stepIndex, stepData);

    yield put({
      type: UPDATE_WIZARD_STEP_SUCCESS,
      payload: { wizardType, wizardState: state },
    });
  } catch (error) {
    yield put({
      type: UPDATE_WIZARD_STEP_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to update wizard step' },
    });
  }
}

function* setCurrentStep({ payload }) {
  try {
    const { shopId, wizardType, stepIndex } = payload;
    const state = yield WizardService.setCurrentStep(shopId, wizardType, stepIndex);

    yield put({
      type: SET_CURRENT_STEP_SUCCESS,
      payload: { wizardType, wizardState: state },
    });
  } catch (error) {
    yield put({
      type: SET_CURRENT_STEP_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to set current step' },
    });
  }
}

function* completeWizard({ payload }) {
  try {
    const { shopId, wizardType } = payload;
    const state = yield WizardService.complete(shopId, wizardType);

    yield put({
      type: COMPLETE_WIZARD_SUCCESS,
      payload: { wizardType, wizardState: state },
    });
  } catch (error) {
    yield put({
      type: COMPLETE_WIZARD_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to complete wizard' },
    });
  }
}

function* resetWizard({ payload }) {
  try {
    const { shopId, wizardType } = payload;
    yield WizardService.reset(shopId, wizardType);

    yield put({
      type: RESET_WIZARD_SUCCESS,
      payload: { wizardType },
    });
  } catch (error) {
    yield put({
      type: RESET_WIZARD_FAILURE,
      payload: { wizardType: payload.wizardType, error: error.message || 'Failed to reset wizard' },
    });
  }
}

export default function* wizardSaga() {
  yield takeLatest(LOAD_WIZARD_STATE, loadWizardState);
  yield takeLatest(INIT_WIZARD, initWizard);
  yield takeLatest(UPDATE_WIZARD_STEP, updateWizardStep);
  yield takeLatest(SET_CURRENT_STEP, setCurrentStep);
  yield takeLatest(COMPLETE_WIZARD, completeWizard);
  yield takeLatest(RESET_WIZARD, resetWizard);
}
